<!-- 签单管理 -->
<template>
	<div>
		<el-card class="box-card">
			<el-form :inline="true">
				<el-form-item label="订单号">
					<el-input style="width: 170px;" placeholder="请填写" v-model="listQuery.search.order_number" clearable> </el-input>
				</el-form-item>
				<el-form-item label="运单号">
					<el-input placeholder="请填写" v-model="listQuery.search.tn_number" clearable> </el-input>
				</el-form-item>
				<el-form-item label="分组:">
					<el-select v-model="listQuery.search.group" clearable placeholder="全部">
						<el-option v-for="item in group_list" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="平台">
					<el-select style="width: 120px;" v-model="listQuery.search.platform" clearable
						placeholder="请选择">
						<el-option v-for="item in platform_list" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="国家">
					<el-select style="width: 120px;" v-model="listQuery.search.country" clearable
						placeholder="请选择">
						<el-option v-for="item in country_list" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态">
					<el-select style="width: 120px;" v-model="listQuery.search.state" clearable
						placeholder="请选择">
						<el-option v-for="item in state_all" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="物流备注">
					<el-input placeholder="请填写" v-model="listQuery.search.wl_remarks" clearable> </el-input>
				</el-form-item>
				<el-button type="danger" @click="handleCreate">添加</el-button>
				<el-button type="danger" @click="handleCreateBatch">批量添加</el-button>
				<el-tooltip class="item" effect="dark" content="仓库发货类型必须上传面单"
					placement="bottom-start">
					<el-button type="success" @click="excelImport">表格导入</el-button>
				</el-tooltip>
			</el-form>
			<el-button type="primary" @click="keySearch"><i class="el-icon-search"></i> 搜索</el-button>
			<el-button type="primary" style="margin-left:30px;" plain @click="resetSearch"><i
					class="el-icon-search"></i>
				重置搜索</el-button>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column prop="platform_init" label="平台" width="80"></el-table-column>
				<el-table-column prop="country_init" label="国家" width="80"></el-table-column>
				<el-table-column prop="group_init" label="分组"></el-table-column>
				<el-table-column prop="send_type_init" label="发货类型" width="80"></el-table-column>
				<el-table-column prop="shop_name" label="店铺名"></el-table-column>
				<el-table-column prop="order_number" label="订单号"></el-table-column>
				<el-table-column prop="tn_number" label="运单号">
					<template slot-scope="{row,$index}">
						<el-button v-if="row.doc_url" type="success" size="mini" @click="shippinglabel(row.id)">打印</el-button>
						<br>
						<span>{{row.tn_number}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="price" label="订单金额">
					<template slot-scope="{row,$index}">
						<span>{{row.price}}({{row.coin_name}}) / {{row.price_rmb}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="收货地址"></el-table-column>
				<el-table-column prop="currency_type_init" label="支付币种" width="80"></el-table-column>
				<el-table-column prop="commission_money" label="佣金" width="80"></el-table-column>
				<el-table-column prop="state" label="状态" width="80">
					<template slot-scope="{row,$index}">
						<el-tag :type="row.state_color">{{row.state_init}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="wl_remarks" label="物流备注" width="80"></el-table-column>
				<el-table-column prop="create_time" label="添加时间"></el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
			<!-- 添加 -->
			<el-dialog :close-on-click-modal="false" title="添加" width="40%" :visible.sync="is_show_create">
				<span>
					<el-form ref="form" label-width="120px" size="medium">
						<el-form-item required label="平台">
							<el-col :span="12">
								<el-select v-model="create_data.platform" clearable placeholder="请选择">
									<el-option v-for="item in platform_list" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item required label="国家">
							<el-col :span="12">
								<el-select v-model="create_data.country" clearable placeholder="请选择">
									<el-option v-for="item in country_list" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item required label="发货类型">
							<el-col :span="12">
								<el-radio-group v-model="create_data.send_type">
								    <el-radio :label="1">仓库发货</el-radio>
								    <el-radio :label="2">商户发货</el-radio>
								  </el-radio-group>
							</el-col>
						</el-form-item>
						<el-form-item label="分组">
							<el-col :span="12">
								<el-select v-model="create_data.group" clearable placeholder="请选择">
									<el-option v-for="item in group_list" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item required label="面单上传">
							<el-col :span="12">
								<PdfUpload @imgList="pdfU" :img_num="1" :img_edit="create_data.doc_url"></PdfUpload>
							</el-col>
						</el-form-item>
						<el-form-item v-if="create_data.doc_url" required label="">
							<el-col :span="12">
								<el-button type="warning" @click="docDo">识别面单</el-button>
							</el-col>
						</el-form-item>
						<el-form-item required label="店铺名">
							<el-col :span="12">
								<el-input placeholder="请填写" v-model="create_data.shop_name" clearable> </el-input>
								</el-input>
							</el-col>
						</el-form-item>
						<el-form-item required label="订单号">
							<el-col :span="12">
								<el-input placeholder="请填写" v-model="create_data.order_number" clearable> </el-input>
								</el-input>
							</el-col>
						</el-form-item>
						<el-form-item required label="运单号">
							<el-col :span="12">
								<el-input placeholder="请填写" v-model="create_data.tn_number" clearable> </el-input>
								</el-input>
							</el-col>
						</el-form-item>
						<el-form-item required label="金额">
							<el-col :span="12">
								<!-- <el-input placeholder="请填写" v-model="create_data.price" clearable> </el-input>
								</el-input> -->
								<el-input-number v-model="create_data.price" :precision="2" :step="0.1"></el-input-number>
							</el-col>
						</el-form-item>
						<el-form-item label="收货地址">
							<el-col :span="12">
								<el-input placeholder="请填写" type="textarea" :rows="4" v-model="create_data.address" clearable> </el-input>
								</el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="物流备注">
							<el-col :span="12">
								<el-input placeholder="选填" v-model="create_data.wl_remarks" clearable> </el-input>
								</el-input>
							</el-col>
						</el-form-item>
					</el-form>
				</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_create = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="createData()">确定
					</el-button>
				</span>
			</el-dialog>
			<!-- 批量添加 -->
			<el-dialog :close-on-click-modal="false" title="批量添加" width="80%" :visible.sync="is_show_create_batch">
				<DocBatchAdd :platform_list="platform_list" :country_list="country_list" :group_list="group_list" :is_show_create_batch="is_show_create_batch"></DocBatchAdd>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_create_batch = false">返回</el-button>
					</el-button>
				</span>
			</el-dialog>
			<!-- 表格导入 -->
			<el-dialog :close-on-click-modal="false" title="表格导入" width="80%" :visible.sync="is_show_create_excel">
				<DocBatchAddExcel :platform_list="platform_list" :country_list="country_list" :group_list="group_list" :is_show_create_batch="is_show_create_excel"></DocBatchAddExcel>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_create_excel = false">返回</el-button>
					</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		orderAdd,
		orderList,
		docAnalysis,
		shippinglabelToken
	} from '@/api/sign_shop'
	import request from '@/tool/request'
	import {
		parseTime,
		alertMsg,
		getBaseUrl
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import PdfUpload from '@/components/Ele/pdfUpload.vue' // 上传pdf组件
	import DocBatchAdd from '@/components/Jd/docBatchAdd.vue' // 批量添加组件
	import DocBatchAddExcel from '@/components/Jd/docBatchAddExcel.vue' // 批量添加组件
	export default {
		components: {
			Pagination,
			PdfUpload,
			DocBatchAdd,
			DocBatchAddExcel
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				is_show_create: false,
				create_data: {},
				group_list:[],// 所有分组
				platform_list:[], // 所有平台
				country_list:[], // 所有国家
				is_show_create_batch:false,
				state_all:[],
				is_show_create_excel:false,
			};
		},
		
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						name: '',
					},
				}
			},
			getList() { // 获取列表数据
				this.loading = true;
				orderList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;
					if(r.platform_list){
						this.platform_list = r.platform_list;
					}
					if(r.country_list){
						this.country_list = r.country_list;
					}
					if(r.group_list){
						this.group_list = r.group_list;
					}
					if(r.state_all){
						this.state_all = r.state_all;
					}
					this.loading = false;
				})
			},
			handleDelete(row, index) {
				groupDel(Qs.stringify(row)).then(response => {
					this.data_list.splice(index, 1);
					alertMsg(this, '删除成功', 'success');
				})
			},
			resetCreateData() { // 重置create_data数据
				this.create_data = {
					id: '',
					platform:'',
					country:'',
					send_type:1,
					group:'',
					doc_url: '',
					address:'',
					order_number:'',
					price:0.00,
					shop_name:'',
					tn_number:'',
				}
			},
			handleCreate() {
				this.resetCreateData();
				this.is_show_create = !this.is_show_create;
			},
			createData() {
				this.$store.commit('setAjaxLoading', true);
				orderAdd(Qs.stringify(this.create_data)).then(response => {
					this.getList();
					this.is_show_create = !this.is_show_create;
					alertMsg(this, '提交成功', 'success');
				})
			},
			// 编辑
			handleUpdate(row) {
				this.create_data = Object.assign({}, row) // copy obj
				this.is_show_create = !this.is_show_create;
			},
			// pdf上传后的回调
			pdfU(e){
				// console.log(e)
				this.create_data.doc_url = e[0].url;
				// console.log(this.create_data.doc_url)
			},
			// 解析面单
			docDo(){
				let post = {
					platform:this.create_data.platform,
					country:this.create_data.country,
					url:this.create_data.doc_url
				}
				docAnalysis(Qs.stringify(post)).then(response => {
					let r = response.result;
					this.create_data.address = r.address;
					this.create_data.order_number = r.order_number;
					this.create_data.price = r.price;
					this.create_data.shop_name = r.shop_name;
					this.create_data.tn_number = r.tn_number;
					alertMsg(this, '识别完成', 'success');
				})
			},
			// 面单打印
			shippinglabel(id) {
				shippinglabelToken(Qs.stringify()).then(response => {
					let r = response.result;
					let token = r.token;
					let uid = r.uid;
					if (token) {
						window.open(getBaseUrl() + "signShippinglabel/index?uid=" + uid +
							"&id=" + id + "&token=" + token,
							"_blank");
					}
				})
			},
			// 批量添加
			handleCreateBatch() {
				this.is_show_create_batch = !this.is_show_create_batch;
			},
			// 表格导入点击
			excelImport(){
				this.is_show_create_excel = true;
			}
		}
	}
</script>
<style>
	textarea {
		font-family: Arial;
	}
</style>